import { DeliveryUsersService } from '@/core/services/delivery-users.service'

import { GetUsersParams, GetUsersResponse } from '@/core/types/delivery-users.types'

const deliveryUsersService = new DeliveryUsersService()

class DeliveryUsersRealisation {
    getUsers(params: GetUsersParams): Promise<GetUsersResponse> {
        return deliveryUsersService.getUsers(params)
    }
}

export const deliveryUsers = new DeliveryUsersRealisation()
